<template>
  <div class="usa-financial">
    <div class="page-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $t('common.finance') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('financial.breadcrumb.usaAccount') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <page-nav :items="tabItems" v-model="activePageNav"></page-nav>
    <keep-alive>
      <component :is="currentPage" :table-height="tableHeight"></component>
    </keep-alive>
  </div>
</template>

<script>
import { getFinancialTabs } from '@/data/financialTabs'
import USARecharge from './Recharge'
import USAExpenditure from './Expenditure'

export default {
  name: 'usa',
  data() {
    return {
      tableHeight: 0,
      activePageNav: 'recharge',
    }
  },
  computed: {
    tabItems() {
      return getFinancialTabs(this.$t.bind(this))
    },
    currentPage() {
      let page = null
      switch (this.activePageNav) {
        case 'recharge':
          page = USARecharge
          break
        case 'expenditure':
          page = USAExpenditure
          break
      }
      return page
    },
  },
  mounted() {
    this.tableHeight = window.innerHeight - 365
  },
}
</script>
